/* tslint:disable */
/* eslint-disable */
/**
 * ADMIN-SERVICE - REST API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 2.1.0-SNAPSHOT
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { exists } from '../runtime';
import { MetaDataFromJSON, MetaDataToJSON, OrganisationUserListEntryFromJSON, OrganisationUserListEntryToJSON, PageRequestFromJSON, PageRequestToJSON, } from './';
export function PagedResponseOfOrganisationUserListEntryFromJSON(json) {
    return PagedResponseOfOrganisationUserListEntryFromJSONTyped(json, false);
}
export function PagedResponseOfOrganisationUserListEntryFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'hasPrevious': !exists(json, 'hasPrevious') ? undefined : json['hasPrevious'],
        'numberOfElements': !exists(json, 'numberOfElements') ? undefined : json['numberOfElements'],
        'hasNext': !exists(json, 'hasNext') ? undefined : json['hasNext'],
        'totalElements': !exists(json, 'totalElements') ? undefined : json['totalElements'],
        'previousPage': !exists(json, 'previousPage') ? undefined : PageRequestFromJSON(json['previousPage']),
        'nextPage': !exists(json, 'nextPage') ? undefined : PageRequestFromJSON(json['nextPage']),
        'entries': !exists(json, 'entries') ? undefined : (json['entries'].map(OrganisationUserListEntryFromJSON)),
        'metaData': !exists(json, 'metaData') ? undefined : MetaDataFromJSON(json['metaData']),
        'page': !exists(json, 'page') ? undefined : json['page'],
        'size': !exists(json, 'size') ? undefined : json['size']
    };
}
export function PagedResponseOfOrganisationUserListEntryToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'hasPrevious': value.hasPrevious,
        'numberOfElements': value.numberOfElements,
        'hasNext': value.hasNext,
        'totalElements': value.totalElements,
        'previousPage': PageRequestToJSON(value.previousPage),
        'nextPage': PageRequestToJSON(value.nextPage),
        'entries': value.entries === undefined ? undefined : (value.entries.map(OrganisationUserListEntryToJSON)),
        'metaData': MetaDataToJSON(value.metaData),
        'page': value.page,
        'size': value.size
    };
}
